/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamusers1Inputs */

const en_entity_teamusers1 = /** @type {(inputs: Entity_Teamusers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Users`)
};

const de_entity_teamusers1 = /** @type {(inputs: Entity_Teamusers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "Team Users" |
*
* @param {Entity_Teamusers1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamusers1 = /** @type {((inputs?: Entity_Teamusers1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamusers1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamusers1(inputs)
	return de_entity_teamusers1(inputs)
});
export { entity_teamusers1 as "entity_teamUsers" }